import React from 'react';
import { Paragraph } from 'common-components/typography';
import { Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { ShiftSlotStatus } from 'utilities/enum-utils';
import AvailabilityConflictTimes from 'views/team/details/tabs-panel/availability/components/AvailablilityConflictTimes';
import { Text } from '@good/ui/core';

interface AssignWorkerStep16Props {
  displayTimezone: string | undefined;
  isEditingBooking: boolean | undefined;
  isRecurring: boolean | undefined;
  onAssignWorker: () => void;
  onChangeSelectedShiftToBeKept: (selectedShiftIds: string[]) => void;
  onClose: () => void;
  onSubmitAssign: () => Promise<void>;
  shiftSlotStatus: ShiftSlotStatus;
  shiftsOutsideGeneralAvailability: unknown[] | null;
}

export const AssignWorkerStep16 = ({
  displayTimezone,
  isEditingBooking,
  isRecurring,
  onAssignWorker,
  onChangeSelectedShiftToBeKept,
  onClose: _onClose,
  onSubmitAssign,
  shiftSlotStatus,
  shiftsOutsideGeneralAvailability,
}: AssignWorkerStep16Props) => {
  return (
    <>
      <Paragraph>
        The new session time conflicts with the team member’s <Text weight='bold'>General availability</Text>. Please
        select which shifts (if any) you wish to keep for the team member or continue without selecting any.
      </Paragraph>
      <div className='bg-quaternary pv-x-large ph-12 mt-x-large'>
        <AvailabilityConflictTimes
          conflicts={shiftsOutsideGeneralAvailability}
          timezone={displayTimezone}
          onSelectShifts={onChangeSelectedShiftToBeKept}
          shiftSlotStatus={shiftSlotStatus}
        />
      </div>
      <div className='mt-x3-large'>
        <Row type={'flex'} justify={'end'}>
          <SecondaryButton size='large' onClick={_onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            size='large'
            className='ml-small'
            onClick={async () => (!isEditingBooking && isRecurring ? await onAssignWorker() : await onSubmitAssign())}
          >
            Continue and assign to selected shifts
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
